import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-floating-bar',
  templateUrl: './floating-bar.component.html',
  styleUrls: ['./floating-bar.component.scss']
})
export class FloatingBarComponent {
  @Input() visible: boolean = true;
  @Input() selectedCount: number = 0;
  @Input() countLabel: string = 'Đã chọn';
  @Input() countUnit: string = 'sản phẩm';
  @Input() clearLabel: string = 'Bỏ chọn';
  @Input() showClearButton: boolean = true;

  @Output() clear = new EventEmitter<void>();

  onClear(): void {
    this.clear.emit();
  }
}
